// extracted by mini-css-extract-plugin
export default {"button":"ButtonBack_button__QbKd7","button--small":"ButtonBack_button--small__qYnyU","button__icon":"ButtonBack_button__icon__voDNc"};